module.exports = "<div class=\"number-display-content\">\n    <div class=\"header\">\n        {{$ctrl.label}}\n    </div>\n    <div class=\"frame\">\n        {{$ctrl.value}}\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/ctxNumberDisplay/ctxNumberDisplay.template.html
// module id = 193
// module chunks = 0 1